<template>
	<div class="main" v-title data-title="零部件分类列表">
		<iHeader></iHeader>
		<div class="flexRow justBetween barprebox">
			<el-breadcrumb separator-class="el-icon-arrow-right" v-if="allcate==false">
				<el-breadcrumb-item v-for="(item,index) in handLoc.title" :key="index" >
					<router-link v-if="item=='首页'" :to="{path:'/'}">{{item}}</router-link>
					<span v-else @click="handbread(handLoc.id[index-1])">
						{{item}}</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
			<el-breadcrumb separator-class="el-icon-arrow-right" v-else-if="allcate==true">
			  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			  <el-breadcrumb-item>全部产品</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="flexRow justBetween barprebox">
			<div class="contL">
				<el-row class="tac">
					<el-col>
						<div class="menu">
							<el-menu :background-color="backgroundColor" :text-color="textColor" :default-active="deactive" :collapse="collapse"
							 :default-openeds="deaopen" @select="handleSelect" @open="handOpen()">
								<template v-for="item in list">
									<el-menu-item :index="item.id.toString()" v-if="item.childids===0" slot="title">
										<i :class="item.icon"></i>
										<span slot="title" class="overtitleOne lin-h50">{{item.title}}</span>
									</el-menu-item>
									<subMenu v-else :data="item" :key="item.id.toString()"></subMenu>
								</template>
							</el-menu>
						</div>
					</el-col>
				</el-row>
			</div>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div>
						<h1 class="color1 font18 item1 ml10"><i class="H-line-4"></i>{{catname}}</h1>
						<el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="inputS" class="Cinput ml10">
						</el-input>
						<el-button type="primary" icon="el-icon-search" @click="handcateSearch()">搜索</el-button>
						<div class="Tnum" v-show="showpage==true">当前共<span class="color2 bold">{{total}}</span>个产品</div>
					</div>
					<div v-if="pageShow==true" style="min-height: 1166px;">
						<div class="demo-image curhand">
							<div class="block blockInfocate" v-for="(item,index) in Ginfo" :key="index" @mousemove="addClassload($event)" @mouseout="removeClassload($event)"
							 @click="jumpurl(item.id,item.is_guobiao)">
								<el-image style="width: 190px; height: 190px" :src="'https://images.mfcad.cn/'+item.thumb"
								 fit="cover" @mousemove="ImgaddClassload($event)" @mouseout="ImgremoveClassload($event)"></el-image>
								<!-- <div class="demonstration font14 fl mt25 color3 h10">{{ item.title }}</div> -->
								<div class="demonstration font14 fl mt25 border-b color3 h10" style="line-height: 15px;">{{ item.title }}</div>
								<div class="font14 fl mt10 bold overtitle" style="width: 100%;">{{catname}}</div>
							</div>
						</div>
						<div class="block pdb10 " style="float: right" v-if="showpage==true">
							<el-pagination @current-change="handleCurrentChange" @size-change="handSizeChange" :current-page.sync="page"
							 :page-sizes="[12, 24, 36]" :page-size="100" layout="prev, pager, next,sizes,total" :total='total'>
							</el-pagination>
						</div>
					</div>
					<div class="txc mt25" v-else>
						<p>暂无数据</p>
					</div>

				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>
<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vFooter from "@/components/Footer"
	import subMenu from "@/components/leftmenu"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
			subMenu
		},
		data() {
			return {
				titleDec: "",
				handLoc: [],
				Ginfo: [],
				currentPage1: 5,
				inputS: '',
				collapse: false, //是否折叠
				backgroundColor: "#ffffff", //导航菜单背景颜色
				textColor: "#6c6e6f", //导航菜单文字颜色
				logo: "LOGO", //logo,
				list: [],
				default_openeds_array: [],
				// 顶级id
				firstID: '',
				//共有多少产品
				total: 1,
				pcount: '12', //每页多少条
				page: 1, //当前页码数
				pageShow: true,
				showpage:false,
				catname: '',
				deactive: '1',
				deaopen:[],
				allcate: false,
			}
		},
		created() {
			this.cateid = this.$route.query.cateid
			this.deaopen.push(this.$route.query.cateid)
			if (this.cateid == '') {
				this.allcate = true
			} else {
				this.allcate = false
			}
			this.deactive = this.cateid;
			this.handClocation(this.cateid);
			this.catelist();
			this.handcateSearch(this.cateid);
		},
		methods: {
			handOpen() {
				this.deactive = this.cateid.toString();
			},
			handbread(catid) {
				let routeData = this.$router.resolve({
					path: "/list/catelist",
					query: {
						cateid: catid,
					}
				})
				this.handClocation(catid);
				this.catelist();
				this.handcateSearch(catid);
				window.open(routeData.href, '_self');
			},
			catelist() {
				this.$postcn('partshome/cate', {}, this).then((res) => {
					this.list = res.data.data;
					this.firstID = res.data.data[0].id;
					// this.handGetMen(this.list,this.cateid)
				})

			},
			jumpurl(id,Ctype) {
				let routeData;
				if(Ctype==1){
					routeData = this.$router.resolve({
						path: "/gb/gbcont",
						query: {
							goodsid: id
						}
					})
				}else{
					routeData = this.$router.resolve({
						path: "/content",
						query: {
							goodsid: id
						}
					})
				}
				window.open(routeData.href, '_blank');
			},
			toggleChildren(item) {
				item.expanded = !item.expanded;
			},
			handleSelect(key, keyPath) {
				let routeData = this.$router.resolve({
					path: "/list/catelist",
					query: {
						cateid: key
					}
				})
				window.open(routeData.href, '_self');
				this.handClocation(key);
				this.handcateSearch(key);
				this.handGetMen(this.list, key)
			},
			handGetMen(list, key) {
				list.map((item, index) => {
					const Citem = item.children;
					if (item.children) {
						this.handGetMen(Citem, key)
						if (item.id == key) {
							this.deaopen = [],
								this.deaopen.push(item.topid.toString(), item.parent_id.toString())
						}
					}
				})
			},
			handClocation(key) {
				this.cateid = key;
				this.$post('partshome/catecrumbs', {
					catid: this.cateid
				}, this).then((res) => {
					this.handLoc = res.data.data;
					this.$set(this.handLoc, 'url', ['/'])
				})
			},
			handleCurrentChange(val) {
				this.page = val;
				this.handcateSearch(this.firstID);
			},
			handSizeChange(val) {
				this.pcount = val;
				this.handcateSearch(this.firstID);
			},
			addClassload($event) {
				$event.currentTarget.className = "block blockInfocate active";
			},
			removeClassload($event) {
				$event.currentTarget.className = "block blockInfocate";
			},
			ImgaddClassload($event) {
				$event.currentTarget.className = "el-image__inner Wactive";
			},
			ImgremoveClassload($event) {
				$event.currentTarget.className = "el-image__inner";
			},
			// 小分类
			handcateSearch(key) {
				this.allcate = false
				if (key == undefined) {
					this.firstID = this.$route.query.cateid
				} else {
					this.firstID = key
				}
				if (this.cateid == '') {
					this.allcate = true
				} else {
					this.allcate = false
				}
				this.$postcn('partshome/productlist', {
					catid: this.firstID, //分类顶级
					searchkeyword: this.inputS, //搜索值
					p: this.page, //第几页
					pcount: this.pcount, //一页显示多少条
					status: '99'
				}, this).then((res) => {
					if (res.data.data.length == 0) {
						this.pageShow = false;
						this.showpage=false;
					} else {
						this.pageShow = true;
						this.showpage=true;
						this.Ginfo = res.data.data;
						this.total = res.data.count;
					}
					this.catname = res.data.catename;
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.el-breadcrumb {
		height: 62px;
		line-height 62px !important;
		font-size: 14px;
	}

	.el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
	.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
		color: #9298a2
	}

	.el-submenu {
		width: 100%
	}

	.el-menu--popup-bottom-start {
		margin-top: 0px !important;
	}

	.el-menu--popup-right-start {
		margin: 0px !important;
	}

	.blockInfocate {
		padding: 10px 10px 20px 10px;
		text-align: center;
		display: inline-block;
		width: 245px;
		margin: 10px;
		box-sizing: border-box;
		vertical-align: top;
		background-color: #fafafa;
		border: 1px solid #eaeaea;
	}

	.h10 {
		height: 30px;
	}

	.demonstration {
		letter-spacing: 0;
		overflow: hidden;
		display: -webkit-box;
		text-overflow: ellipsis;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		line-height: 20px;
		width: 100%;
	}

	.el-submenu__icon-arrow {
		right: 10px;
	}

	.Cinput {
		display: inline-block !important;
		width: 300px !important;
	}

	.item1 {
		display: inline-block;
	}

	.Tnum {
		display: inline-block;
		float: right;
		margin-right: 30px;
		line-height: 40px;
	}

	.active {
		border-color: #1f75cf;
		color: #1f75cf;
	}

	.el-submenu .el-menu-item,
	.el-submenu__title {
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
		// width: 220px;
	}

	.overtitle {
		overflow: hidden;
		/*超出部分隐藏*/
		text-overflow: ellipsis;
		/* 超出部分显示省略号 */
		white-space: nowrap;
		/*规定段落中的文本不进行换行 */
		width: 240px;
	}

	.Wactive {
		width: 190PX;
		cursor: pointer;
		transform: scale(1.5, 1.5)
	}
</style>
<style>
	.el-input--prefix .el-input__inner {
		padding-left: 30px !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/list/catelist.vue